export const SOFTLINE_API_SCAN_LAGERPLATZ = "/v1/lagerplatzinhalt/scan-lagerplatz/{{code}}";
export const SOFTLINE_API_LAGERKORREKTUR = '/v1/lagerkorrektur';
